import React from 'react'
import { Image as AntdImage, Space, message } from 'antd'
import { DownloadImageIcon, DownloadPDFIcon, RotateLeftIcon, ZoomInIcon, ZoomOutIcon } from 'src/assets/icons'
import jsPDF from 'jspdf'
import './index.scss'
import { useTranslation } from 'react-i18next'

interface ImageProps {
  width: number | string
  height: number
  src: string
  checkNumber: string
}

const Image: React.FC<ImageProps> = ({ checkNumber, width, height, src }) => {
  const { t } = useTranslation()
  const getFilename = (extension: string) => {
    const currentDate = new Date()
    const currentMonth = `${currentDate.getMonth() + 1}`.padStart(2, '0')
    const currentDay = `${currentDate.getDate()}`.padStart(2, '0')
    const currentYear = currentDate.getFullYear()
    const formattedDate = `${currentMonth}.${currentDay}.${currentYear}`
    return `CheckNumber_${checkNumber}_${formattedDate}.${extension}`
  }
  const onJPGDownload = () => {
    fetch(src)
      .then((response) => response.blob())
      .then((blob) => {
        message.loading(t('OverallFunctionality:downloading_toast_msg'))
        const url = URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.download = getFilename('jpg')
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url)
        link.remove()
      })
  }

  const onPDFDownload = () => {
    message.loading(t('OverallFunctionality:downloading_toast_msg'))
    const doc = new jsPDF('p', 'px')
    doc.addImage(src, 'JPEG', 10, 10, 430, 200)
    doc.save(getFilename('pdf'))
  }

  return (
    <div className='common-image-wrap'>
      <AntdImage
        className='common-image'
        width={width}
        height={height}
        src={src}
        preview={{
          toolbarRender: (_, { transform: { scale }, actions: { onRotateLeft, onZoomOut, onZoomIn } }) => (
            <Space size={32} style={{ borderRadius: '60px' }} className='toolbar-wrapper'>
              <DownloadImageIcon onClick={onJPGDownload} />
              <DownloadPDFIcon onClick={onPDFDownload} />
              <RotateLeftIcon onClick={onRotateLeft} />
              <ZoomOutIcon onClick={onZoomOut} />
              <ZoomInIcon onClick={onZoomIn} />
            </Space>
          ),
        }}
      />
    </div>
  )
}

export default Image
